const PrivacyPolicy = () => {
  return (
    <div
      style={{
        backgroundColor: "#0d1320",
        minHeight: "100vh",
        color: "#e5e7eb",
      }}
    >
      <header className="bg-[#0d1320] shadow w-full z-10">
        <div className="max-w-5xl mx-auto py-4 px-6 flex justify-center">
          <h1 className="text-2xl font-semibold text-white underline text-center">
            Privacy Policy
          </h1>
        </div>
      </header>

      <main className="px-6 max-w-5xl mx-auto pb-16">
        <p className="text-sm text-gray-600 mb-4">Last Updated: May 20, 2025</p>

        <p className="mb-4">
          Onelyk (“we,” “our,” or “us”) is committed to protecting the privacy
          of our customers and their guests. This Privacy Policy describes how
          we collect, use, disclose, and safeguard personal information through
          our guest engagement and review management software.
        </p>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            1. Information We Collect
          </h2>
          <p className="mb-2">
            We may collect the following types of information:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Guest contact details: Name, email, phone number, and booking
              information.
            </li>
            <li>
              Usage data: Interactions with our platform and communication
              history.
            </li>
            <li>
              Hotel property and staff data necessary to support your account.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            2. How We Use Information
          </h2>
          <p className="mb-2">We use guest and customer data to:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Facilitate guest communications and automated messaging.</li>
            <li>
              Collect and manage guest reviews across third-party platforms.
            </li>
            <li>Analyze performance metrics and optimize guest engagement.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            3. Legal Basis for Processing
          </h2>
          <p className="mb-2">
            We rely on consent (where required), contract obligations, and
            legitimate interests to collect and use personal data.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            4. Sharing of Information
          </h2>
          <p>We do not sell guest or customer data. We may share data with:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Review platforms (e.g., Google, TripAdvisor) as authorized by you.
            </li>
            <li>
              Third-party vendors or services required to operate our software.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">5. Data Security</h2>
          <p>
            We implement reasonable technical and organizational measures to
            protect data, including encryption, access controls, and secure
            cloud infrastructure (e.g., AWS).
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">6. Data Retention</h2>
          <p>
            We retain guest and user data only for as long as necessary to
            fulfill the purposes described, unless a longer retention period is
            required by law.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">7. Your Rights</h2>
          <p>
            Depending on your location, you may have rights to access, correct,
            delete, or restrict personal data we hold about you. To exercise
            these rights, please contact us.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">8. Children’s Privacy</h2>
          <p>
            Our platform is not directed at individuals under 18. We do not
            knowingly collect personal data from minors.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            9. Changes to This Policy
          </h2>
          <p>
            We may update this Privacy Policy periodically. Continued use of our
            Service after changes means you accept the updated terms.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            10. Contact Information
          </h2>
          <p>
            Onelyk Inc.
            <br />
            Email:{" "}
            <a
              href="mailto:support@onelyk.com"
              className="text-blue-600 hover:underline"
            >
              support@onelyk.com
            </a>
            <br/>
          </p>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
